import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';

export type ClientUser = {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobileNumber?: string;
  mobileCountryCode?: string;
  status?: string;
  [key: string]: unknown;
};

export async function fetchClients(params: Record<string, unknown> = {}) {
  const { data } = await httpClient.get(endpoints.clients.list, { params });
  return data;
}

export async function fetchClientById(clientId: string) {
  const { data } = await httpClient.get(endpoints.clients.detail(clientId));
  return data;
}

export async function createClient(payload: Record<string, unknown>) {
  const { data } = await httpClient.post(endpoints.clients.create, payload);
  return data;
}

export async function updateClient(
  clientId: string,
  payload: Record<string, unknown>,
) {
  const { data } = await httpClient.patch(
    endpoints.clients.update(clientId),
    payload,
  );
  return data;
}

export async function deleteClient(clientId: string) {
  const { data } = await httpClient.delete(endpoints.clients.delete(clientId));
  return data;
}
